import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicInflammationDiagramContent } from "./CardiometabolicInflammationDiagram";
import { CardiometabolicInflammationKeyContent } from "./CardiometabolicInflammationKey";

const SvgCardiometabolicInflammationDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1370, 1614)}
      viewBox={diagramOnly ? "0 170 1024 1370" : "0 0 1024 1614"}
    >
      <g id="cardiometabolic-inflammation-diagram+key" clipPath="url(#clip0_18293_231788)">
        <rect width={1024} height={diagramOnly ? 1370 : 1614} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <CardiometabolicInflammationKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <CardiometabolicInflammationDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_231788">
          <rect width={1024} height={1614} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_231788">
          <rect width={1024} height={1370} fill="white" transform="translate(0 170)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicInflammationDiagramKey;
